"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringReplacer = exports.parseStringFloat = exports.formatPrice = exports.formatPhoneNumber = exports.formatAddressAsTwoArray = exports.formatAddress = exports.combineValues = exports.ImageUrlGenerator = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var parseStringFloat = function parseStringFloat(number) {
  var showSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return "".concat(number < 0 ? "-" : "").concat(showSign ? "$" : "").concat(parseFloat(Math.abs(number)).toFixed(2));
};

exports.parseStringFloat = parseStringFloat;

var combineValues = function combineValues(_ref) {
  var _ref$delivery = _ref.delivery,
      delivery = _ref$delivery === void 0 ? 0 : _ref$delivery,
      _ref$prep = _ref.prep,
      prep = _ref$prep === void 0 ? 0 : _ref$prep,
      _ref$pickup = _ref.pickup,
      pickup = _ref$pickup === void 0 ? 0 : _ref$pickup;
  var orderType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pickup";
  var safePickup = pickup || 0;
  var safeDelivery = delivery || 0;
  var safePrep = prep || 0;
  var baseValue = orderType === "delivery" ? safeDelivery : safePickup;
  return safePrep + baseValue;
};

exports.combineValues = combineValues;

var stringReplacer = function stringReplacer(str, arr) {
  var newStr = str;
  arr.forEach(function (targetString) {
    newStr = newStr.replace(targetString.replaceTarget, targetString.replaceValue);
  });
  return newStr;
};

exports.stringReplacer = stringReplacer;

var formatPhoneNumber = function formatPhoneNumber(phoneNumberString) {
  var cleaned = "".concat(phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "".concat(match[1], "-").concat(match[2], "-").concat(match[3]);
  }

  return "";
};

exports.formatPhoneNumber = formatPhoneNumber;

var formatPrice = function formatPrice(price) {
  var showSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return Array.isArray(price) ? "".concat(parseStringFloat(price[0], showSign), " - ").concat(parseStringFloat(price[1], showSign)) : parseStringFloat(price, showSign);
};

exports.formatPrice = formatPrice;
var baseURL = "https://assets.lunchbox.io";

var ImageUrlGenerator = function ImageUrlGenerator(image, config) {
  return "".concat(baseURL, "/").concat(config.directory, "/images/").concat(image);
};

exports.ImageUrlGenerator = ImageUrlGenerator;

var addComma = function addComma(value) {
  return "".concat(value ? "".concat(value, ",") : "");
};

var DEFAULT_ADDRESS = {
  city: "",
  state: "",
  street1: "",
  street2: "",
  zip: ""
};

var formatAddress = function formatAddress() {
  var inputAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var address = _objectSpread(_objectSpread({}, DEFAULT_ADDRESS), inputAddress);

  return "".concat(addComma(address.street1)).concat(addComma(address.street2), " ").concat(addComma(address.city), " ").concat(address.state, " ").concat(address.zip);
};

exports.formatAddress = formatAddress;

var formatAddressAsTwoArray = function formatAddressAsTwoArray() {
  var inputAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var address = _objectSpread(_objectSpread({}, DEFAULT_ADDRESS), inputAddress);

  var address1 = "".concat(addComma(address.street1)).concat(addComma(address.street2));
  var address2 = "".concat(addComma(address.city), " ").concat(address.state, " ").concat(address.zip);
  return [address1, address2];
};

exports.formatAddressAsTwoArray = formatAddressAsTwoArray;